import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=1d9d523d&scoped=true"
import script from "./BlogList.vue?vue&type=script&lang=js"
export * from "./BlogList.vue?vue&type=script&lang=js"
import style0 from "./BlogList.vue?vue&type=style&index=0&id=1d9d523d&prod&lang=scss&scoped=true"
import style1 from "./BlogList.vue?vue&type=style&index=1&id=1d9d523d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9d523d",
  null
  
)

export default component.exports